export default __webpack_public_path__ + "static/media/a16z.62bc5ae9.svg";